import request from '../utils/request';

// 获取包邮规则
export const fetchShippingRule = () => request.get('/admin/shipping-rule');

// 保存包邮规则
export const saveShippingRule = (data) => request.put('/admin/shipping-rule', data);

// 试算运费
export const calculateShippingFee = (data) => request.post('/admin/shipping-rule/calculate', data);